export const REGISTRATION_STATUS_TOTAL_DAYS = 45;

export default {
  REGISTRATION_STATUS_TOTAL_DAYS
};
